import React from 'react'
import '../components_css/pc.css'
import Logo from '../images/pc/logoBottom.png'
import LogoText from '../images/pc/ToyDogeCoin.svg'
import LogoImg from '../images/pc/LOGO-doge.png'
import titleFirst  from '../images/pc/character2x.png'
import titleSecond  from '../images/pc/token.png'
import titleThird  from '../images/pc/documents2x.png'
import titleForth  from '../images/pc/roadmap1x.png'
import icon1  from '../images/pc/icon-1.png'
import icon2  from '../images/pc/icon-2.png'
import icon3  from '../images/pc/icon-3.png'
import icon4  from '../images/pc/icon-4.png'
import icon5  from '../images/pc/icon-5.png'
import icon6  from '../images/pc/icon-6.png'
import coin1  from '../images/pc/coin1.png'
import coin2  from '../images/pc/coin2.png'
import coin3  from '../images/pc/coin3.png'
import dogeLeft  from '../images/pc/dogeLeft.png'
import dogeRight  from '../images/pc/dogeRight.png'
import Vector  from '../images/pc/Vector.png'
import TwitterBlack from '../images/pc/TwitterBlack.png'
import VectorBlack from '../images/pc/VectorBlack.png'
// import Telegram  from '../images/pc/Telegram.png'
import backTop  from '../images/pc/backTop.svg'
import toydoge  from '../images/pc/toydoge.png'
import toydoge2  from '../images/pc/toydoge2.png'
import toydoge3  from '../images/pc/toydoge3.png'
import toydoge4  from '../images/pc/toydoge4.png'
import toydoge5  from '../images/pc/toydoge5.png'
import toydoge6  from '../images/pc/toydoge6.png'
import Telegram  from '../images/pc/Telegram.svg'
import Negative  from '../images/pc/Negative.svg'
import boneLeft  from '../images/pc/boneLeft.png'
import boneRight  from '../images/pc/boneRight.png'
import coingecko  from '../images/pc/cg-logo.png'
import bsc  from '../images/pc/bsc-logo.png'
import cmc  from '../images/pc/cmc-logo.png'
import babySwap  from '../images/pc/babyswap-logo.png'
import mainTitle from '../images/pc/mainTitle.svg'
import $ from 'jquery';

import API from '../api';
import {
  Row,
  Col,
  message, //消息
  } from "antd";
import 'antd/dist/antd.css';
import Footer from "./news_footer";

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.initPage = 1
    this.state = {
      list: [
        {name: 'Page1 - 自定义动画', class: 'page1', hasStep: true},
        {name: 'Page2 - 定制分页', class: 'page2', hasTips: true},
        {name: 'Page3 - 侦测内容长度滚动', class: 'page3', hasList: true},
        {name: 'Page4 - 动态添加page', class: 'page4', isAdd: true},
      ],
      curPage: this.initPage,
      pageTop: window.screen.availHeight/2 - 128,
      alreadyNum: 0,
      visible: false,
      organizationName: "",
      user: "",
      phone: "",
      unameHelp: "",
      upwdHelp: "",
      uphoneHelp: "",
      hash: "",
      menu: ['Character', 'Tokenomic', 'Documents', 'Roadmap', 'Friends', 'Charts'],
      thirdArr: ['Phase 1', 'Phase 2', 'Phase 3', 'Phase 4', 'Phase 5', 'Phase 6'],
      thirdIndex: 0,
      showToTopIconStatus: 0
    }
  }

  // componentWillReceiveProps (nextProps) {
    
  //   this.slideTo(nextProps)
  // }
  onBefore(origin, direction, target) {
    console.log(target)
    this.setState({curPage: target})
  }
  prevPage() {
    this.refs['SlideContainer'].slidePrev()
  }
  nextPage() {
    this.refs['SlideContainer'].slideNext()
  }
  slideTo(page) {
    this.refs['SlideContainer'].slideTo(page)
    this.setState({curPage: page})
  }
  // 点击导航
  clickMenu(item) {
    console.log(item.key)
    this.slideTo(item.key)
  }
  showModal = () => {
    this.setState({
      visible: true,
    });
  }

  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  }

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  }
  
  setMenu(index){
    let menu = this.state.menu
    let ddAnchorElement = $("#rootIn");
    if(index >= 0){
      this.setState({
        index
      }, ()=>{
        let anchorName = menu[index]
        if (anchorName && anchorName != 'Charts') {
          // 找到锚点
          let anchorElement = document.getElementById(anchorName);
          console.log(anchorElement, anchorElement.offsetTop)
          // 如果对应id的锚点存在，就跳转到锚点
          if (anchorElement) {
      
            console.log(anchorElement, anchorElement.offsetTop, 'offsetParent')
            // ddAnchorElement.scrollTop = anchorElement.offsetTop
            ddAnchorElement.animate({ scrollTop: anchorElement.offsetTop }, 800)
          }
        }else{
          window.open('https://poocoin.app/tokens/0x6205eBd05dE85430b7B54E662d2dCB3bA53b12b6')
        }
      })
    }else{
      ddAnchorElement.animate({ scrollTop: 0 }, 1000)
    }
    
  }
  setIndex(index){
    this.setState({
      thirdIndex: index
    })
  }
  handleScroll(e){
    let ddAnchor = document.getElementById('rootIn')
    // let ddAnchor = $("#rootIn");
    let showToTopIconStatus = this.state.showToTopIconStatus
    // console.log(ddAnchor.scrollTop, e.target.clientHeight, showToTopIconStatus, 'param')
    if (ddAnchor.scrollTop > e.target.clientHeight && !showToTopIconStatus) {
      console.log(ddAnchor.scrollTop, e.target.clientHeight, showToTopIconStatus, '出现')
      this.setState({showToTopIconStatus: true})
    } else if (ddAnchor.scrollTop < e.target.clientHeight && showToTopIconStatus) {
      console.log(ddAnchor.scrollTop, e.target.clientHeight, showToTopIconStatus, '消失')
      this.setState({showToTopIconStatus: false})
    }
  }
  backToTop(){
    // console.log(navKey, 'navKey')
    // scrollToAnchor('')
    this.setMenu(-1)
  }
  copy(){
    // document.execCommand("Copy")
    
    var oInput = document.createElement('input');
    oInput.value = '0x6205eBd05dE85430b7B54E662d2dCB3bA53b12b6';
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象
    document.execCommand("Copy"); // 执行浏览器复制命令
    oInput.className = 'oInput';
    oInput.style.display='none';
    message.success('Copy succeeded!')
    
  }
  toBuy(){
    window.open('https://exchange.babyswap.finance/#/swap?outputCurrency=0x6205ebd05de85430b7b54e662d2dcb3ba53b12b6')
  }
  componentDidMount(){
    let ddAnchor = document.getElementById('rootIn')
    ddAnchor.addEventListener('scroll', this.handleScroll.bind(this), true)
  }
  render() {
    let {list, curPage} = this.state;
    // console.log(curPage+'')
    var selectedKeys = []
    selectedKeys.push(curPage+'')  
    // console.log(curPage+'',mm)
    return (
      <div className='rootContent' id='rootContent'>
        <header>
          <div className='menuTop' >
              <div className='logoLeft'>
                {/* <img className='logo' src={Logo}/>
                <span>Toy Doge Coin</span> */}
                <img className='logo' src={LogoImg}/>
                <div className='rightBtn'>
                  <a href="https://twitter.com/ToyDogeCoin" target="_blank"><img src={TwitterBlack} /></a>&emsp;
                  <a href="https://t.me/ToyDogeCoinChat" target="_blank"><img src={VectorBlack} /></a>
                </div>
              </div>
              <div className="menuContainer">
                  {
                    this.state.menu.map((item, index)=>{
                        return <span
                            className='menu'
                            // style={{color: this.state.index === index ? '#6560FF' : '#22283F'}} 
                            onClick={()=>this.setMenu(index)}
                        >
                          {item}
                        </span>
                    })
                  }
              </div>
             
          </div>
          
          <Row gutter={24} type="flex" justify="start">
            <Col xl={12} md={12} xs={12}>
              
              <article className="content" >
                {/* <h1 className="main-title-two">Toy Doge Coin Ecosystem = MEME + DeFi + NFT + GameFi</h1> */}
                <img className="main-title-two" src={mainTitle}></img>
                <p className="sub-two">Toy Doge Coin is the foundation of Toy Doge Ecosystem and is a more friendly MEME token. It is responsible for letting more people know about the crypto world and at the same time participate in children's charities. It will be familiarized by the public like Dogecoin, while it has a higher mission.</p>
                <div className="sub-button">
                  <Row gutter={12} type="flex" justify="start">
                    <Col xl={18} md={18} xs={18}>
                      <div className="sub-button-container">
                        <span>0x6205eBd05dE85430b7B54E662d2dCB3bA53b12b6</span>&emsp;
                        <a onClick={this.copy} className="sub-button-style">Copy Address</a>
                      </div>
                    </Col>
                    <Col xl={6} md={6} xs={6}>
                      <a target="_blank" style={{marginTop: '4px'}} className="sub-button-style" onClick={this.toBuy} href="https://exchange.babyswap.finance/#/swap?outputCurrency=0x6205ebd05de85430b7b54e662d2dcb3ba53b12b6" className="sub-button-style">Buy on BabySwap</a>
                    </Col>
                  </Row>
                  
                </div>
                
              </article>
            </Col>
          </Row>
          <div className="thirdArea" >
            <img className="boneLeft" src={boneLeft} />
            <img className="boneRight" src={boneRight} />
            <Row type="flex" justify='center'>
              <Col  xl={6} md={6} xs={6}>
              
                <div className="thirdItem">
                  <div className="thirdPrice">$&nbsp;0.0000000001</div>
                  <div className="secondText">Current Price</div>
                </div>
                
              </Col>
              <Col  xl={6} md={6} xs={6}>
                
                <div className="thirdItem">
                  <div className="thirdPrice">0</div>
                  <div className="secondText">Holders</div>
                </div>
              </Col>
              <Col  xl={6} md={6} xs={6}>
                
                <div className="thirdItem">
                  <div className="thirdPrice">1,000,000,000,000,000</div>
                  <div className="secondText">Supply</div>
                </div>
              </Col>
              <Col  xl={6} md={6} xs={6}>
                
                <div className="thirdItem">
                  <div className="thirdPrice">$100,000</div>
                  <div className="secondText">Market Cap</div>
                </div>
              </Col>
            </Row>
          </div>
        </header>
        <div className="container">
          <div className="service"  id="Character">
            <div className="title text-center">
              <img className="titleImg" src={titleFirst} />
            </div>
            <div className="flex-box-4">
              <Row type="flex" justify='center'>
                <Col  xl={12} md={12} xs={12}>
                
                  <div className="box">
                    <img src={icon1} alt="" />
                    <span className="content">
                      <h2 className="main-title text-left">Community-Powered</h2>
                      <p className="sub text-left">Completely community-powered with every force we can get. We accept ALL concepts and opinions to make it the best community.</p>
                    </span>
                  
                  </div>
                  
                </Col>
                <Col  xl={12} md={12} xs={12}>
                  
                  <div className="box">
                    <img src={icon4} alt="" />
                    <span className="content">
                      <h2 className="main-title text-left">Automatic LP Burned</h2>
                      <p className="sub text-left">All LP will be burned (Burned! NOT locked!), no matter it's the initial LP build by the team or the future-added once. That's our big Vision!</p>
                    </span>
                  </div>
                </Col>
                <Col  xl={12} md={12} xs={12}>
                  
                  <div className="box">
                    <img src={icon2} alt="" />
                    <span className="content">
                      <h2 className="main-title text-left">Dev Burn</h2>
                      <p className="sub text-left">The 10% tokens that belong to the devs team will be burned. It means 0.5% of the transaction volume is going to burn, deflation for life!</p>
                    </span>
                  </div>
                </Col>
                <Col  xl={12} md={12} xs={12}>
                  
                  <div className="box">
                    <img src={icon5} alt="" />
                    <span className="content">
                      <h2 className="main-title text-left">GameFi: Play & Earn</h2>
                      <div className="sub text-left">Your NFT can be used to participate in the game. Completing the daily tasks can level up your NFT, more rewards and fun for you!</div>
                    </span>
                  </div>
                </Col>
                <Col  xl={12} md={12} xs={12}>
                  
                  <div className="box">
                    <img src={icon3} alt="" />
                    <span className="content">
                      <h2 className="main-title text-left">NFT Wallet</h2>
                      <div className="sub text-left">5% of the tokens is used to be redistributed in NFT wallet, which means there will be more and more NFT minted and staking income increases, each child has its own NFT!</div>
                    </span>
                  </div>
                </Col>
                <Col  xl={12} md={12} xs={12}>
                
                  <div className="box">
                    <img src={icon6} alt="" />
                    <span className="content">
                      <h2 className="main-title text-left">Charity & Marketing Wallet</h2>
                      <p className="sub text-left">1% of the tokens is used to be redistributed in Charity wallet, and we will continually put ourselves in children's charity! 1% of the tokens is used to be redistributed in Marketing wallet, and we will carry out long-term PR to attract more people!</p>
                    </span>
                  
                  </div>
                  
                </Col>
              </Row>
            </div>
            
          </div>
          <div className="course" id="Tokenomic">,
            <div className="title text-center">
              <img className="titleImg" src={titleSecond} />
            </div>

            <div className="flex-box">
              <Row gutter={[16, 16]} type="flex" justify='center'>
                <Col  xl={8} md={8} xs={24}>
                
                  <div className="boxCoin">
                    <img src={coin1} alt="" />
                    <span className="content">
                      <h2 className="main-title text-left">5%</h2>
                      <p className="subCoin text-left">of each transaction redistributed to holders (Including Burn, Marketing, Charity, NFT wallets and so on).</p>
                    </span>
                  
                  </div>
                  
                </Col>
                <Col  xl={8} md={8} xs={24}>
                  
                  <div className="boxCoin">
                    <img src={coin3} alt="" />
                    <span className="content">
                      <h2 className="main-title text-left">5%</h2>
                      <p className="subCoin text-left">of each transaction added to TOYDOGE liquidity on BabySwap.</p>
                      {/* <p className="subCoin text-left">of each transaction added to TOYDOGE liquidity.</p> */}
                    </span>
                  </div>
                </Col>
                <Col  xl={8} md={8} xs={24}>
                  
                  <div className="boxCoin">
                    <img src={coin2} alt="" />
                    <span className="content">
                      <h2 className="main-title text-left">2%</h2>
                      {/* <p className="subCoin text-left">of each transaction added to the core token’s liquidity of the DEX we cooperate with.</p> */}
                      
                      <p className="subCoin text-left">of each transaction added to BABY liquidity on BabySwap.</p>
                    </span>
                  </div>
                </Col>
                
              
              </Row>
        
            </div>
          </div>
          <div className="map"  id="Documents">
            <div className="title text-center">
              <img className="titleImg" src={titleThird} />
            </div>
            <div className="fiveArea">
              <Row gutter={32} type="flex" justify='center'>
                <Col  sm={24} lg={12} className="col-center">
                
                  <div className="fiveItem">
                    <div className="fiveTextItem">
                      <img src={dogeLeft} className="fiveTextImg"/>
                      <div className="fivePrice text-right"><a target="_blank" href="https://drive.google.com/file/d/1DG3pD4jfNWPgqOYEhtybtQE_KdKK4ird/view?usp=sharing">White Paper ></a></div>
                    </div>
                    
                  </div>
                  
                </Col>
                <Col  sm={24} lg={12} className="col-center">
                  
                  <div className="fiveItemR">
                    
                    <div className="fiveTextItem">
                     
                      <div className="fivePrice text-left"><a target="_blank" href="https://www.certik.org/projects/toydogecoin">Audit Report > </a></div>
                      <img src={dogeRight} className="fiveTextImgR"/>
                    </div>
                  </div>
                  
                </Col>
                
              </Row>
					  </div>
          </div>

         
          <div className="serviceLast"  id="Roadmap">
            <div className="bg-bone">
              <div className="title text-center">
                <img className="titleImg" src={titleForth} />
              </div>
              <div className="flex-box-forth">
                
                <Row gutter={24} type="flex" justify='center'>
                  <Col  xl={15} md={15} xs={15} className="topCol" style={{textAlign: 'center',}}>
                  <div className='forthDiv'>
                    {
                        this.state.thirdArr.map((item, index)=>{
                            return <span 
                                className={this.state.thirdIndex === index ? 'menuActive' : 'menuDef'} 

                                onClick={()=>this.setIndex(index)}
                            >
                                {item}
                            </span>
                        })
                    }
                
                  </div>
                  </Col>
                  
                </Row>
                <Row gutter={24} type="flex" justify='center'>
                  <Col  xl={20} md={20} xs={20} className="centerCol" style={{textAlign: 'center',}}>
                  {
                    (
                      () => {
                        switch (this.state.thirdIndex) {
                          case 0:
                            return <div className='forthCenter'>
                              <div>Acknowledgment by the Public </div>
                              <div>Official Website Launch </div>
                              <div>Telegram Reaches 1,000 People</div>
                              <div>Audit by Third Parties</div>
                              <img  className="toydoge" src={toydoge}></img>
                            </div>
                          case 1:
                            return <div className='forthCenter'>
                              <div>KOL Promotion </div>
                              {/* <div>IDO</div> */}
                              <div>BabySwap IDO</div>
                              <div>CoinMarketCap Listing </div>
                              <div>Telegram reaches 10,000 People</div>
                              <img  className="toydogeR" src={toydoge2}></img>
                            </div>
                          case 2:
                            return <div className='forthCenter'>
                              <div>More Exposure in Crypto</div>
                              <div>Listing on Major CEX</div>
                              <div>100,000 Holders</div>
                              <div>Toy Doge Swap Launch</div>
                              <img  className="toydoge" src={toydoge3}></img>
                            </div>
                          case 3:
                            return <div className='forthCenter'>
                              <div>Get Access to Traditional Media</div>
                              <div>150,000 Holders</div>
                              <div>ToyDoge NFT Online</div>
                              <div> Donate $100K when the Market Cap is $100M</div>
                              <img  className="toydogeR" src={toydoge4}></img>
                            </div>
                          case 4:
                            return <div className='forthCenter'>
                              <div>More Exposure from Traditional Media</div>
                              <div>300,000 Holders</div>
                              <div>ToyDoge GameFi online</div>
                              <div>Donate $200K when the Market Cap is $500M</div>
                              <img  className="toydoge" src={toydoge5}></img>
                            </div>
                          default:
                            return <div className='forthCenter'>
                              <div>Capture the Real World</div>
                              <div>500,000 Holders</div>
                              <div>Donate $500K when the Market Cap is $1B</div>
                              <div>Toy Doge Wallet Online</div>
                              <div>Toy Doge Figure Production</div>
                              <div>The best Crypto Funds for</div> 
                              <div>Children's Charity</div>
                              <img  className="toydogeR" src={toydoge6}></img>
                            </div>
                        }
                      }
                    )()
                  }
                    
                  </Col>
                  
                </Row>
                
              </div>
              <div className="space">
                  
              </div>
            </div>
            
           
          </div>
          <div className="bottomImg" id="Friends">
            {/* <Row gutter={24} type="flex" justify='center'>
                <Col  xl={20} md={20} xs={20} className="centerCol" style={{textAlign: 'center',}}>
                </Col>
                  
            </Row> */}
            <a target="_blank" href="https://home.babyswap.finance/"><img src={babySwap}/></a>
            <a target="_blank" href="https://bscscan.com/token/0x6205ebd05de85430b7b54e662d2dcb3ba53b12b6"><img src={bsc}/></a>
            <a ><img src={cmc} /></a>
            <a ><img src={coingecko} /></a>
           
          </div>
        </div>

        <footer>
          <Row gutter={24} type="flex" justify='center'>
            <Col  xl={12} md={12} xs={24}>
            
              <div className="left pull-left">
                <ul className="contact">
                  <li>
                    <img className="qc-img" src={Logo} /><img className="qc-text" src={LogoText} />&emsp;&emsp;
                    {/* <span>ToyDogeCoin</span> */}
                  </li>
                  <li>Toy Doge is a fun meme with a serious mission to help BABY to grow with happiness, bring crypto adoption to the real world with new concepts.</li>
                  {/* <li>
                    <img src={email} />&nbsp;&nbsp;beihewendou2008@163.com
                  </li> */}
                </ul>
               
              </div>
              
            </Col>
            <Col  xl={12} md={12} xs={24}>
              <div className="right pull-left">
                <ul className="tool">
                  {/* <li>
                    <img className="tool-img" src={Negative} />&emsp;twitter.com/ToyDogeCoin
                  </li>
                  <li>
                    <img className="tool-img" src={Telegram} />&emsp;t.me/ToyDogeCoinChat
                  </li> */}
                  <li>
                    <img className="tool-img" src={Negative} />&emsp;<a target="_blank" href="https://twitter.com/ToyDogeCoin">twitter.com/ToyDogeCoin</a>
                  </li>
                  <li>
                    <img className="tool-img" src={Telegram} />&emsp;<a target="_blank" href="https://t.me/ToyDogeCoinChat">t.me/ToyDogeCoinChat</a>
                  </li>
                </ul>
              </div>
             
            
            </Col>
            
          </Row>
         
        </footer>
        {
          this.state.showToTopIconStatus ? <div className="backToTop" onClick={this.backToTop.bind(this)}>
            <img src={backTop} />
          </div> : ''
        }
        
      </div>
    );
  }
}








// WEBPACK FOOTER //
// ./src/components/container.js